import React, { useEffect, useState, useContext } from 'react';

import { ResponsiveHeader } from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/SkipLinks';
import { skipLinks } from '../links';
import { authenticateUser } from '../../../client/authenticate-user';
import { Navigation } from '../navigation/Navigation';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import { getUserProfile } from '../../../client/getUserProfile';

interface HeaderWrapperProps {
  features: Features;
}

export const HeaderWrapper = ({ features }: HeaderWrapperProps) => {
  const [mobileNavShown, setMobileNavShown] = useState<boolean>(false);
  const [typeaheadIsOpen, setTypeaheadIsOpen] = useState<boolean>(false);

  const { updateUserState } = useContext(UserContext) as any;

  useEffect(function initUserState() {
    if (features.authenticationEnabled) {
      authenticateUser(updateUserState);
    } else if (!features.authenticationEnabled) {
      const userProfile = getUserProfile();
      updateUserState(userProfile);
    }
  }, []);

  return (
    <header className={styles.siteWide}>
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />
        <ResponsiveHeader
          updateMobileNavState={setMobileNavShown}
          updateTypeaheadState={setTypeaheadIsOpen}
        />
      </div>
      <Navigation
        mobileNavShown={mobileNavShown}
        typeaheadIsOpen={typeaheadIsOpen}
      />
    </header>
  );
};
